module.exports = __webpack_public_path__ + "img/pay-per-click.912e9271.png";